// Whether this browser last chose the new experience, as the sidebar switch
// records it. Remembered when the legacy card's switch flips on
// (src/modules/Sidebar/newExperienceExit.js), forgotten when Core's flips off
// (core/src/legacyExit.js), and read by the legacy router when an auditor
// arrives at the root (a bookmark to app.auditminer.com), so the bookmark lands
// where they last chose to be.
//
// A cookie, not a server-side setting: the quick version, per review. It is
// per browser rather than per user, so two people sharing a machine share the
// choice; a per-user record is the follow-up if that bites. Shared by both
// apps, so it lives under `shared/` (Core imports nothing from `src/`).
// Prefixed like the app's other cookies (`auditminer_assuming_*`).
const NAME = 'auditminer_new_experience'
const ONE_YEAR_S = 60 * 60 * 24 * 365

function write(value, maxAgeSeconds) {
  if (typeof document === 'undefined') return
  const secure = typeof location !== 'undefined' && location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${NAME}=${value}; Path=/; Max-Age=${maxAgeSeconds}; SameSite=Lax${secure}`
}

export function rememberNewExperience() {
  write('1', ONE_YEAR_S)
}

export function forgetNewExperience() {
  write('', 0)
}

export function prefersNewExperience() {
  if (typeof document === 'undefined') return false
  return new RegExp(`(?:^|; )${NAME}=1(?:;|$)`).test(document.cookie)
}
